import React from 'react';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="201"
    height="153"
    viewBox="0 0 201 153"
  >
    <path d="M63.97 121.121L16.242 73.394.333 89.303l63.637 63.636L200.333 16.576 184.424.666z" />
  </svg>
);
